// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriptionV2AccountPrescriptionGetByAccountIdAccountIdGetByAccountIdResponse {
    static getAttributeTypeMap() {
        return PrescriptionV2AccountPrescriptionGetByAccountIdAccountIdGetByAccountIdResponse.attributeTypeMap;
    }
}
PrescriptionV2AccountPrescriptionGetByAccountIdAccountIdGetByAccountIdResponse.discriminator = undefined;
PrescriptionV2AccountPrescriptionGetByAccountIdAccountIdGetByAccountIdResponse.additionalProperties = false;
PrescriptionV2AccountPrescriptionGetByAccountIdAccountIdGetByAccountIdResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=prescriptionV2AccountPrescriptionGetByAccountIdAccountIdGetByAccountIdResponse.js.map